import { useSelector } from 'react-redux';

import * as utils from '../../../utils';
import classes from '../UserAccessReview.module.scss';
import { UAR_CONSTANTS } from '../util/constants';

const BulkProfile = () => {
	const bulkSelections = useSelector(state => state.uar.bulkSelections);

	return (
		<section
			id='profileDetails'
			className={utils.concatenateClassNames(
				['profile', 'profile__container'],
				classes
			)}
		>
			<div
				className={utils.concatenateClassNames(
					['profile__item', 'profile-details__item'],
					classes
				)}
			>
				{bulkSelections.map(details => {
					const displayName = details
						? details.isServiceAccount ||
						  details.type === UAR_CONSTANTS.SERVICE_ACCOUNT_KEY
							? details.familiarEsoId
								? `${details.familiarEsoId} (Service Account)`
								: `${details.eso} (Service Account)`
							: details.firstName +
							  ' ' +
							  details.middleInitial +
							  ' ' +
							  details.lastName
						: 'unknown';
					return (
						<div
							className={utils.concatenateClassNames(
								['title'],
								classes
							)}
						>
							{displayName}
						</div>
					);
				})}
			</div>
		</section>
	);
};

export default BulkProfile;
